import { render, staticRenderFns } from "./SellCategoryEditModal.vue?vue&type=template&id=4278f12b&scoped=true"
import script from "./SellCategoryEditModal.vue?vue&type=script&lang=ts"
export * from "./SellCategoryEditModal.vue?vue&type=script&lang=ts"
import style0 from "./SellCategoryEditModal.vue?vue&type=style&index=0&id=4278f12b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278f12b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4278f12b')) {
      api.createRecord('4278f12b', component.options)
    } else {
      api.reload('4278f12b', component.options)
    }
    module.hot.accept("./SellCategoryEditModal.vue?vue&type=template&id=4278f12b&scoped=true", function () {
      api.rerender('4278f12b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/SellCategoryEditModal.vue"
export default component.exports